export default class MakePrescription{
	dialysisRecipe:DialysisRecipe = new DialysisRecipe()
    recipeConsumables:Array<object>
    recipeAntis:Array<object>
}
//处方入参数据辅助类
class DialysisRecipe {
    //患者透析生命体征Id
    dialysisSignId:number = 0
    //透析模式(HD,HF,HDF,HP,HDP,CRRT)
    dialysisWay:string = ''
    //干体重
    dryWeight:number = 0
    beforeSbp:number = 0
    beforeWeight:number = 0

    //净体重
    jWeight:number = 0
    
    //偏移量
    offset:number = 0
    //脉搏
    heartRate:number = 0
    //回水量
    backWater:number = 0
    //引血上机
    isYxsj:boolean = true
    //预设超滤量
    ultrafiltrationVolume:number = 0
    //抗凝方式（1:普通肝素,2:低分子肝素,3:枸橼酸,4:无肝素,5:阿加曲班;ufh_lmwh:普肝+低分子;in_vitro_ac:体外肝素化抗凝）
    anticoagulationWays:number = 0
    //抗凝剂对应药品id
    anticoagulateMedId:number = 0
    //首剂肝素(ml)
    anticoagulantFirst:number = 0
    //抗凝剂单位
    anticoagulationUnit:string
    //追加肝素/小时(ml)
    anticoagulantAdd:number = 0
    //抗凝剂备注
    acRemark:string =''
    //门诊 住院
    patientType:number = 1
    //是否保存至处方模板
    savetoTemplateFlag:boolean = true
    //血管通路
    patVaId:number
    //评估(出血，容量丢失，浮肿，未诉不适，其他，心肺扩张)
    assess:string = ''
    //list
    assessList:Array<string> = ['未诉不适']
    //评估补充说明
    assessRemark:string = ''
    //透析液流量（ml/min）
    dialysateFlowRate:number = 0
    //透析液温度（℃）
    dialysateTemperature:number = 0
    //透析液浓度钙（mmol/L）
    dialysateconcCa:number = 0
    //透析液浓度镁（mmol/L）
    dialysateconcMg:number = 0
    //透析液浓度氯（mmol/L）
    dialysateconcCl:number = 0
    //透析液浓度醋酸根（mmol/L）
    dialysateconcAc:number = 0
    //透析液浓度钠（mmol/L）
    dialysateconcNa:number = 0
    //透析液浓度钾（mmol/L）
    dialysateconcK:number = 0
    //透析液浓度碳酸氢盐（mmol/L）
    dialysateconcHco3:number = 0
    //透析液浓度碳酸葡萄糖（mmol/L）
    dialysateconcGlucose:number = 0
    //置换液
    substitutionFluidTotal:number = 0
    //置换液稀释方式
    substitutionDilutionType:string = 0
    //血流速度(ml/min)
    bloodVelocity:number = 0
    //透析时间(分钟)
    dialysisTime:number = 0
    //生理盐水（mL）
    normalSaline:number = 0
    //备注
    remarks:string = ''
}
//透析处方对应的抗凝剂集合
class RecipeAntis {
    antiWays:number = 30
    // 抗凝方式（数据字典对应的Id）
    medId:number = 0
    // 抗凝剂对应药品id
    antiFirstDose:number = 0
    // 首剂
    antiFirstUnit:string = ''
    // 首剂单位
    antiAddDose:number = 0
    // 追加/小时
    dose:number = 0
    // 枸橼酸剂量(ml/h)
    gaMedId:number = 0
    // 钙剂药品Id
    gaDose:number = 0
    // 钙剂剂量(ML)
    normalSalineMedId:number = 0
    // 生理盐水药品Id
    normalSalineDose:number = 0
    // 生理盐水剂量（ML）
    pumpDose:number = 0
    // 泵 入( ml/h)
}




// WEBPACK FOOTER //
// ./src/views/dialysisProcess/waitRoom/makePrescriptionForm.ts